import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useAuthContext } from 'modules/auth/context';
import { getQuestionReportInbox } from './api';
import type { QuestionReportStatus } from './constants';

/** Per organization, so switching organization never shows another tenant's reports from the cache. */
export const questionReportsInboxKey = (orgId: string | undefined, testId: string | undefined, status: QuestionReportStatus) =>
  ['questionReports', 'inbox', orgId, testId, status] as const;

/** The reported questions of one test, for one status tab. Keeps the previous tab on screen while the next loads. */
export function useQuestionReportsInbox(testId: string | undefined, status: QuestionReportStatus) {
  const { state } = useAuthContext();
  const orgId = state.organization?.id;
  return useQuery({
    queryKey: questionReportsInboxKey(orgId, testId, status),
    queryFn: ({ signal }) => getQuestionReportInbox(testId!, status, signal),
    enabled: Boolean(testId),
    placeholderData: keepPreviousData,
    staleTime: 30_000,
  });
}
